module.exports = __webpack_public_path__ + "img/sup_withdraw_bank2.ab009f8f.jpg";